import React, { useState } from 'react';
import Resizer from "react-image-file-resizer";
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from '../../AppContext.js';
import axios from 'axios' ;
function BuyAccount() {
  const [caption, setCaption] = useState('');
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const [mota, setMota] = useState('');
  const [money, setmoney] = useState('');
  const [image, setImage] = useState(null);
  const [loginInfo, setLoginInfo] = useState('');
  const [is2fa, setIs2fa] = useState(false);
  const [isclone, setIsclone] = useState(false);
  const [showExampleImage, setShowExampleImage] = useState(false);

  const handleCaptionChange = (event) => {
    setCaption(event.target.value);
  };
  const handlemoneyChange = (event) => {
    setmoney(event.target.value);
  };

  const handleMotaChange = (event) => {
    setMota(event.target.value);
  };

  const handleImageChange = (event) => {
        
    const file = event.target.files[0];
    // Kiểm tra định dạng tệp tin
    if (!file.type.startsWith("image/")) {
      alert_error("File không phải là ảnh.");
      return;
    }

    // Kiểm tra kích thước tệp tin
    const maxSize = 3 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      alert_error("Kích thước tệp tin vượt quá 3MB.");
      return;
    }
    Resizer.imageFileResizer(
      file,
      400, // Chiều rộng mới (điều chỉnh theo nhu cầu)
      400, // Chiều cao mới (điều chỉnh theo nhu cầu)
      "PNG", // Định dạng đầu ra ("PNG" trong trường hợp này)
      80, // Chất lượng ảnh đầu ra (từ 0 - 100)
      0, // Độ xoay (0 đối với không xoay)
      (uri) => {
        // Xử lý ảnh sau khi đã chuyển đổi thành PNG
        // uri chứa đường dẫn của ảnh mới
        setImage(uri);
      },
      "base64" // Đầu ra là base64
    );

   
  };

  const handleLoginInfoChange = (event) => {
    setLoginInfo(event.target.value);
  };

  const handleAuthMethodChange = (event) => {
    setIs2fa(event.target.checked);
  };

  const handleVirtualCloneChange = (event) => {
    setIsclone(event.target.checked);
  };

  const handleImagePreview = () => {
    setShowExampleImage(true);
  };

  const handleClosePreview = () => {
    setShowExampleImage(false);
  };

  const handleSubmit = (event) => {
    setnutorder('Please wait a moment 😊') ;
      setnutxuly(1)
    const myCookieValue = Cookies.get('apikey');
    event.preventDefault();
    axios
    .post('https://hust.media/nosql/addservice.php', {
      caption: caption ,
    key: myCookieValue ,
    mota: mota ,
    money: money ,
    loginInfo: loginInfo ,
    is2fa: is2fa.toString() ,
    isclone: isclone.toString() ,
    chedo:  'addaccount' ,
    image: image ,
    })
    .then(response => {
    if ( response.data.status == 0 )
    {  
    alert_error(response.data.message) ;
    }
    else if ( response.data.status  == 1 )
    {
      alert_success(response.data.message) ;
    }
    setnutorder('đặt tiếp luôn nào') ;
    setnutxuly(0)
  })
    .catch(error =>  { alert_error(error) ;
    setnutorder('Lỗi vui lòng thử lại') ;
    setnutxuly(0) } )
       

    // Sau khi gửi thành công, bạn có thể đặt lại các giá trị trong form
    // setCaption('');
    // setMota('');
    // setImage(null);
    // setLoginInfo('');
    // setIs2fa(false);
    // setIsclone(false);
  };

  return (
    <div className="flex items-center justify-center ">
      <div className="max-w-md p-6 bg-white rounded-lg shadow-md">
        <div className="text-xl font-semibold text-gray-800 mb-2">Bán Tài Khoản tiktok</div>
        <form onSubmit={handleSubmit}>
          <div className="mb-2">
            <label htmlFor="caption" >
            <div className="block text-gray-700 font-medium mb-0">     Tiêu đề  </div>
            <div className="mt-0 text-xs mb-2" >ví dụ: TÀI KHOẢN TIKTOK ĐÃ ĐỦ LIVE STUDIO ( ĐÃ LIVE 25P )</div>
            </label>
            <input
              type="text"
              id="caption"
              placeholder="Điền tiêu đề"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={caption}
              onChange={handleCaptionChange}
              required
            />
            
          </div>
          <div className="mb-2">
            <label htmlFor="mota" >
            <div className="block text-gray-700 font-medium mb-0">   Mô tả  </div>
            <div className="mt-0 text-xs mb-2" >
ví dụ : Tài Khoản TikTok Chất Lượng Có Live - Follow  Có 1.000-3.000 Follow ( Đã Live 25p - Không Video )  
TÀI KHOẢN ĐÃ DUYỆT LIVESTUDIO , AE LẤY ACC VỀ LÀ LIVE ĐƯỢC LUÔN.
Định Dạng :   ID | Pass | Mail | Pass Mail 
</div>
            </label>
            <textarea
              id="mota"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Điền mô tả"
              value={mota}
              onChange={handleMotaChange}
              required
            ></textarea>
          </div>
          <div className="mb-2">
            <label htmlFor="caption" className="block text-gray-700 font-medium mb-1">
              Giá bán 1 tài khoản
            </label>
            <input
              type="number"
              id="money"
              placeholder="vd: 9000"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={money}
              onChange={handlemoneyChange}
              required
            />
          </div>
          <div className="mb-3">
         
            <div className="flex items-center">
            <label htmlFor="image" className="block text-gray-700 font-medium mb-2">
               Ảnh icon tiktok
            </label>
           
                <>
                  <button
                    type="button"
                    className="ml-2 text-blue-500 underline"
                    onClick={handleImagePreview}
                  >
                    Xem ví dụ ảnh
                  </button>
                  {showExampleImage && (
                    <div className="absolute top-auto left-0 z-10 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
                      <div className="p-4 bg-white">
                        <img
                          src="https://taphoammo.net/img/tai-khoan-tiktok-a-u-live-studio-a-live-25p_959295792.png"
                          alt="Ví dụ ảnh"
                          className="w-60 h-60 mx-auto mb-4"
                        />
                        <button
                          type="button"
                          className="text-sm block w-full bg-blue-500 text-white py-1 px-2 rounded-md hover:bg-blue-600 transition-colors"
                          onClick={handleClosePreview}
                        >
                          Đóng
                        </button>
                      </div>
                    </div>
                  )}
                </>
          
            </div>
            <input
                type="file"
                id="image"
                className="w-full"
                accept="image/*"
                onChange={handleImageChange}
                required
              />
          </div>
          <div className="mb-2">
            <label htmlFor="loginInfo" className="block text-gray-700 font-medium mb-2">
              Thông tin đăng nhập (user|pass|...)
            </label>
            <input
              type="text"
              id="loginInfo"
              placeholder="vd: ID | Pass | Mail | Pass Mail "
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={loginInfo}
              onChange={handleLoginInfoChange}
              required
            />
          </div>
          <div className="flex items-center mb-2">
            <input
              type="checkbox"
              id="authMethod"
              className="mr-2"
              checked={is2fa}
              onChange={handleAuthMethodChange}
            />
            <label htmlFor="authMethod" className="text-gray-700">
              Tài khoản bạn có phương thức xác thực khác (số điện thoại, 2fa, v.v.)?
            </label>
          </div>
          <div className="flex items-center mb-2">
            <input
              type="checkbox"
              id="virtualClone"
              className="mr-2"
              checked={isclone}
              onChange={handleVirtualCloneChange}
            />
            <label htmlFor="virtualClone" className="text-gray-700">
              Tài khoản là clone tài khoản ảo?
            </label>
          </div>
          <div className="text-xs" >Phí đăng bán tài khoản tiktok là 100 Coins</div>
        <button disabled={nutxuly}  onClick={handleSubmit}
              className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
              <div className='flex items-center justify-between flex-1'>
               { nutxuly == 1 &&
                <div className="spinner-border" role="status">
               
                </div>}
               
             
                <span className='text-lg font-medium text-white'> 
                { nutorder } </span>
                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
              </div>
            </button>
        </form>
      </div>
    </div>
  );
}

export default BuyAccount;
